<script setup>
import { ref, onMounted } from "vue";
import Event from "./Event.vue";
import Post from "./Post.vue";
import Highlight from "./Highlight.vue";
import MoreLink from "../components/MoreLink";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const store = useFilteredFeedStore();
const { endpoint } = store;

defineProps({
	wrapClass: {
		type: String,
		required: false,
	},
	title: {
		type: String,
		required: false,
	},
	items: {
		type: Array,
		required: true,
	},
	isFeatured: {
		type: Boolean,
		required: false,
		default: () => {
			return false;
		},
	},
	pagination: {
		type: Boolean,
		required: false,
		default: () => {
			return true;
		},
	},
});

function isWide(index) {
	return index % 5 >= 2 && index % 5 <= 4;
}
</script>

<template>
	<Transition>
		<section>
			<div :class="store.endpoint == 'event' ? 'feed alternating' : 'media'">
				<template v-if="store.endpoint == 'event'">
					<template v-for="(item, index) in items" :key="index">
						<Event :item="item" :class="{ 'grid-item--thin': isWide(index) }" />
						<Highlight v-if="index === 6 && store.highlight" :item="store.highlight" />
					</template>
				</template>
				<Post v-for="(item, index) in items" :item="item" :key="index" v-if="store.endpoint == 'post'" />
			</div>
			<MoreLink v-if="store.hasMorePages" />
		</section>
	</Transition>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
	opacity: 0;
}
@media (prefers-reduced-motion) {
	.v-enter-active,
	.v-leave-active {
		transition: opacity 0s linear;
	}
}
</style>
